import React from "react";
import { CarouselModal } from "@src/lms/jelly/extensions/layouts/_lesson/case7/common/components/CarouselModal";
import { useIntl } from "react-intl";

import styles from "./BuffModal.module.scss";
import { messages } from "../Case1ArtisticPov.messages";
import { useUi } from "@jelly/lesson";

type BioNoteModalProps = Omit<React.ComponentProps<typeof CarouselModal>, "children">;
export const BuffModal: React.FC<BioNoteModalProps> = (props) => {
  const { formatMessage } = useIntl();
  const ui = useUi();

  let linkToPresent = "placeholder-link";
  try {
    const url = new URL(formatMessage(messages.bioBuffLink));
    linkToPresent = url.host;
  } catch {
    // ...
  }

  return (
    <ui.Modal {...props} title={formatMessage(messages.bioBuffTitle)}>
      <div className={styles.slide}>
        <div className={styles.content}>{formatMessage(messages.bioBuffDescription)}</div>
        <div className={styles.link}>
          <ui.Button
            size="small"
            shape={"normal"}
            theme={"primary"}
            onClick={() => window.open(formatMessage(messages.bioBuffLink))}
          >
            {linkToPresent}
          </ui.Button>
        </div>
      </div>
    </ui.Modal>
  );
};

//TODO: override scrollbars colors
